import Image from 'next/image';
import Link from 'next/link';
import classes from './ad.module.css';

const IMAGE_WIDTH = 706;
const IMAGE_HEIGHT = 760;

const GalleryAd = props => {
  const { item } = props;

  const imgSrc = item.img;

  return (
    <div style={{ gridColumn: 'span 2' }}>
      <Link className={`${classes.info} w-full cursor-pointer block`} href={item.link}>
        <Image
          src={imgSrc}
          width={IMAGE_WIDTH}
          height={IMAGE_HEIGHT}
          className='w-full'
          alt=''
        />
      </Link>
    </div>
  );
};

export default GalleryAd;
